import Vue from 'vue';
import VueOnboarding from 'vue-tour';
import onboardingIsSeen from 'onboarding/utils/onboardingIsSeen';
import Cookie from 'js-cookie';
import store from 'store';
import {isCurrentAppSeller} from 'utils/appTypeState';

const DISABLE_ONBOARDINGS_KEY = 'disable_onboardings';


class OnboardingManager {
  constructor () {
    if (this._instance) {
      return this._instance;
    }
    this._instance = this;

    Vue.use(VueOnboarding);
    this.lockPromise = null;
    this.activeOnboarding = null;
  }

  async checkOnboardingCondition (onboardingClass) {
    const onboardingName = onboardingClass.name;
    const quickstartAccount = isCurrentAppSeller() ? false : store.getters['quickstart/quickstartAccount'];

    // do not show onboardings if quickstart is active
    if (!onboardingClass.canRunAgain && onboardingIsSeen(onboardingName) ||
      Boolean(Cookie.get(DISABLE_ONBOARDINGS_KEY)) || quickstartAccount) {
      return false;
    }

    const onboarding = new onboardingClass();
    return await onboarding.constructor.checkCondition();
  }

  async scheduleOnboarding (onboardingClass, trackingParams = {}, payload = {}) {
    if (this.lockPromise) {
      // wait before previous scheduled dashboard is checked
      await this.lockPromise;
    }
    let lockResolve;
    this.lockPromise = new Promise(resolve => {
      lockResolve = resolve;
    });
    const condition = await this.checkOnboardingCondition(onboardingClass);
    lockResolve();
    this.lockPromise = null;

    if (!condition || this.activeOnboarding !== null) {
      return;
    }
    return this.run(onboardingClass, trackingParams, payload);
  }

  async run (onboardingClass, trackingParams, payload) {
    this.activeOnboarding = new onboardingClass(trackingParams);

    const onboardingPromise = this.activeOnboarding.run(payload);

    onboardingPromise.then(() => {
      this.activeOnboarding = null;
    });

    return this.activeOnboarding;
  }
}

const onboardingManager = new OnboardingManager();

export default onboardingManager;
